export const usePriceFormatter = () => {
  function formatPrice(price: number | string): string {
    return price ? window.hyva.formatPrice(Number(price)) : '';
  }

  return {
    formatPrice,
  };
};
